import React from "react";
import { dataDefaultFetch, postDataAPI } from "../../../../utils/fetchData";
import { Button, Flex, Form, Modal, Space, Table } from "antd";
import AdjustFormUrlDirect from "./adjustFormUR";

export default function UrlsRedirect() {
  // const [searchFilter, setSearchFilter] = React.useState("");

  const [form] = Form.useForm();

  const [page, setPage] = React.useState({
    page: 0,
    limit_page: 5,
    filters: {is_delete: false},
  });

  const [urls, setUrls] = React.useState(dataDefaultFetch);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [open, setOpen] = React.useState(false);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const hasSelected = selectedRowKeys.length > 0;

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  async function getUrl() {
    try {
      setUrls({ ...urls, loading: true });
      const res = await postDataAPI("urlsRed/all", page);

      setUrls({
        ...urls,
        data: res.data?.data,
        loading: false,
        total: res.data?.total,
      });
    } catch (error) {
      setUrls({ ...urls, data: null, loading: false, error: error });
    }
  }

  React.useEffect(() => {
    getUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const columns = [
    {
      title: "Id",
      dataIndex: "_id",
      key: "_id",
      render: (_) => {
        return <span>{String(_).slice(-4)}</span>;
      },
    },
    {
      title: "Original Url",
      dataIndex: "origin_url",
      key: "origin_url",
      render: (_) => {
        return `${window.location.origin}${_}`;
      },
    },
    {
      title: "Target Url",
      key: "target_url",
      dataIndex: "target_url",
      render: (_) => {
        return (
          <a
            target="_blank"
            href={
              _ === "home"
                ? `${window.location.origin}`
                : `${window.location.origin}/${_}`
            }
            rel="noreferrer"
          >
            {_ === "home"
              ? `${window.location.origin}`
              : `${window.location.origin}/${_}`}
          </a>
        );
      },
    },
    {
      title: "Actions",
      key: "action",
      render: (url) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={async () => {
              setOpen(true);
              form.setFieldValue("url", url);
            }}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  const hanldeSumitForm = async () => {
    try {
      await form.validateFields(); // Validate form fields
      form.submit();
    } catch (error) {}
  };
  return (
    <>
      <Flex justify="space-between">
        <Space style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            onClick={() => setOpen(true)}
            disabled={!hasSelected}
          >
            Delete selected rows
          </Button>
          <span
            style={{
              marginLeft: 8,
              fontSize: "12px",
            }}
          >
            {hasSelected ? `Đã chọn ${selectedRowKeys.length} bài viết` : ""}
          </span>
        </Space>
        <Space style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setSelectedRowKeys([])
            }}
          >
            Create
          </Button>
        </Space>
      </Flex>

      <Table
        columns={columns}
        rowSelection={rowSelection}
        dataSource={urls.data || []}
        loading={urls?.loading}
        rowKey={"_id"}
        pagination={{
          total: urls?.total,
          pageSize: page.limit_page,
          current: page.page + 1,
          onChange: (e) => setPage({ ...page, page: --e, limit_page: 5, filters: {is_delete: false}}),
        }}
      />
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false);
          setSelectedRowKeys([])
          form.setFieldValue("url", null)
        }}
        onOk={hanldeSumitForm}
        okText="Save Changes"
        maskClosable={false}
        title="Url Hanled Form"
        destroyOnClose
      >
        <AdjustFormUrlDirect
          form={form}
          setOpen={setOpen}
          setPage={setPage}
          selectedRows={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          dataUrls={urls.data}
        />
      </Modal>
    </>
  );
}
